import { Lines, Reveal } from "./motion";
import { Eyebrow } from "./ui-bits";

export const PageHero = ({ eyebrow, lines, sublines, intro, testid }) => (
  <section className="px-5 pb-16 pt-36 sm:px-10 md:pb-24 md:pt-48 lg:px-16" data-testid={testid}>
    <div className="grid grid-cols-12 gap-y-10">
      <div className="col-span-12 lg:col-span-9">
        <Reveal delay={0.5}><Eyebrow>{eyebrow}</Eyebrow></Reveal>
        <Lines as="h1" onLoad delay={0.55} lines={lines} className="mt-8 text-[2.15rem] leading-[1.08] tracking-[-0.01em] sm:text-6xl lg:text-7xl" />
        {sublines && <Lines as="h2" onLoad delay={0.8} lines={sublines} className="mt-3 text-[2.15rem] leading-[1.08] tracking-[-0.01em] text-teal sm:text-6xl lg:text-7xl" />}
      </div>
      {intro && (
        <Reveal delay={0.9} className="col-span-12 md:col-span-7 md:col-start-6 lg:col-span-4 lg:col-start-9 lg:self-end">
          <p className="text-base leading-relaxed text-ink/75 md:text-lg">{intro}</p>
        </Reveal>
      )}
    </div>
  </section>
);
